import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import type { ProjectStatus } from '@/types/project';

interface Args {
  projectId: string;
  newStatus: ProjectStatus;
}

const isRlsError = (err: any): boolean => {
  const msg = (err?.message || '').toLowerCase();
  return (
    err?.code === '42501' ||
    msg.includes('row-level security') ||
    msg.includes('permission denied') ||
    msg.includes('insufficient_privilege')
  );
};

export const useUpdateProjectStatus = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ projectId, newStatus }: Args) => {
      const { error } = await supabase
        .from('projects')
        .update({ status: newStatus })
        .eq('id', projectId);
      if (error) throw error;
    },
    onSuccess: (_d, { projectId }) => {
      qc.invalidateQueries({ queryKey: ['project', projectId] });
      qc.invalidateQueries({ queryKey: ['project-edit', projectId] });
      qc.invalidateQueries({ queryKey: ['project-detail', projectId] });
      qc.invalidateQueries({
        queryKey: ['projects-optimized-v2'],
        exact: false,
        refetchType: 'active',
      });
      qc.invalidateQueries({
        queryKey: ['projects', 'status-stats'],
        exact: false,
        refetchType: 'active',
      });
      toast.success('Đã đổi trạng thái dự án');
    },
    onError: (err: any) => {
      if (isRlsError(err)) toast.error('Bạn không có quyền đổi trạng thái dự án');
      else toast.error(err?.message || 'Không đổi được trạng thái');
    },
  });
};
